export default {"src":"/_next/static/media/ear-muffs.96c57240.svg","height":164,"width":194,"blurWidth":0,"blurHeight":0};